import { Candidate } from "./types";

export const newCandidateColors1 = {
  default: "bg-emerald-600",
  hover: "bg-emerald-700",
  selected: "bg-emerald-800",
};

export const newCandidateColors2 = {
  default: "bg-violet-600",
  hover: "bg-violet-700",
  selected: "bg-violet-800",
}

export const candidates: Candidate[] = [
  {
    name: "Joe Biden",
    styles: {
      default: "bg-sky-600",
      hover: "bg-sky-700",
      selected: "bg-sky-800",
    }
  },
  {
    name: "Donald Trump",
    styles: {
      default: "bg-red-600",
      hover: "bg-red-700",
      selected: "bg-red-800",
    }
  },
  {
    name: "Nikki Haley",
    styles: {
      default: "bg-rose-600",
      hover: "bg-rose-700",
      selected: "bg-rose-800",
    }
  },
  {
    name: "Barack Obama",
    styles: {
      default: "bg-indigo-600",
      hover: "bg-indigo-700",
      selected: "bg-indigo-800",
    }
  },
  {
    name: "Kamala Harris",
    styles: {
      default: "bg-amber-600",
      hover: "bg-amber-700",
      selected: "bg-amber-800",
    }
  }
]

export const DefaultQuestions: string[] = [
  "What specific steps will you take to improve access to quality healthcare, reduce healthcare costs, and enhance public health infrastructure?",
  "How do you plan to strengthen international alliances, address global threats, and maintain national security in an increasingly interconnected world?",
  "What measures will you take to balance responsible gun ownership with public safety, especially in light of recent mass shootings?",
  "What steps will you take to improve K-12 education, address student loan debt, and make higher education more affordable and accessible?",
  "What comprehensive immigration reforms do you propose, considering border security, pathways to citizenship, and the fate of DACA recipients?",
  "With the pandemic's impact still lingering, how do you plan to strengthen the economy and support struggling businesses and workers?"
];

export const DefaultTopics: string[] = [
  "Immigration and Border Security",
  "Economic Recovery and Job Creation",
  "Education and Student Debt",
  "Climate Change and Environmental Policy",
  "Technology and Privacy",
  "Gun Control and Public Safety",
  "Racial Equity and Social Justice"
];